<div>
  <!-- Titulo Card Registrar Nueva Sesion Entrenamiento -->
  <h1 class="bg-azul text-white p-5 text-center text-xl">
    {{ 'registrar-nueva-sesion' | translate }}
  </h1>
  <!-- Contenedor de Datos Nueva Sesion Entrenamiento -->
  <div mat-dialog-content>
    <!-- Formulario Rango Fechas Nueva Sesion -->
    <form *ngIf="mostrarSelectorFechaSesion" [formGroup]="formNuevaSesion" class="grid grid-cols-1 md:grid-cols-2 gap-4 p-3">
      <mat-form-field appearance="outline" class="col-span-full" hideRequiredMarker>
        <mat-label class="m-2">{{ 'fechas' | translate }}</mat-label>
        <!-- Input Rango Fechas -->
        <mat-date-range-input formGroupName="rangoFechas" [rangePicker]="picker">
          <input matStartDate placeholder="{{ 'fecha-inicio' | translate }}" formControlName="fechaInicio">
          <input matEndDate   placeholder="{{ 'fecha-fin'   | translate }}" formControlName="fechaFin">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <!-- Errores Fechas Requeridas -->
        <mat-error *ngIf="formNuevaSesion.get('rangoFechas.fechaInicio')?.hasError('required')">{{ 'req-fecha-inicio' | translate }}</mat-error>
        <mat-error *ngIf="formNuevaSesion.get('rangoFechas.fechaFin')?.hasError('required')">{{ 'req-fecha-fin' | translate }}</mat-error>
      </mat-form-field>
      <!-- Errores Fechas Invalidas -->
      <mat-error class="col-span-full" *ngIf="formNuevaSesion.hasError('inferiorActual')">{{ 'error-fecha-actual' | translate }}</mat-error>
      <mat-error class="col-span-full" *ngIf="formNuevaSesion.hasError('rangoInvalido')">{{ 'error-fecha-fin' | translate }}</mat-error>
      <!-- Boton Establecer Fechas -->
      <button [disabled]="!formNuevaSesion.valid" class="col-span-full bg-azul p-2 text-white my-2 rounded-lg hover:text-blue-300 duration-1000" (click)="establecerEntrenamientosSesion()">
        {{'establecer-entrenamientos' | translate}}
      </button>
    </form>
    <!-- Contenedor Dias Sesion -->
    <div class="animate-fade-down" *ngIf="mostrarDiasSesion" [formGroup]="formNuevaSesion">
      <div>
        <h3 class="animate-fade text-center text-azul text-lg font-bold">{{'establecer-entrenamientos-sesion' | translate}}</h3>
        <!-- Contenedor Dias Sesion -->
        <ng-container *ngFor="let dia of [].constructor(diasSesion); let i = index">
          <!-- Contenedor Informacion Entrenamiento Dia Sesion -->
          <div *ngIf="mostrarDia[i]" class="border-2 border-azul p-4 mb-3 rounded grid grid-cols-1 md:grid-cols-2 gap-4">  
            <h3 class="col-span-full text-center text-azul font-bold">{{'dia' | translate}} {{ i + 1 }}</h3>
            <!-- Input Fecha Entrenamiento -->
            <input type="date" [(ngModel)]="fechasDias[i]" [ngModelOptions]="{ standalone: true }" [min]="fechaInicioString" [max]="fechaFinString" (ngModelChange)="validarFecha(i)" class="rounded p-2 col-span-full text-black border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            <p *ngIf="fechasInvalidas[i]" class="text-red-500">{{'fecha-fuera-rango' | translate}}</p>
            <!-- Select Entrenamiento existente o nuevo -->
            <div *ngIf="!fechasInvalidas[i]" class="col-span-full">
              <select class="rounded p-2 w-full text-black border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" [(ngModel)]="usarEntrenamiento" [ngModelOptions]="{ standalone: true }">
                <option [ngValue]="true">{{'entrenamiento-existente' | translate}}</option>
                <option [ngValue]="false">{{'crear-nuevo-entrenamiento' | translate}}</option>
              </select>
            </div>
            <!-- Contenedor Nuevo Entrenamiento -->
            <div class="col-span-full" *ngIf="!usarEntrenamiento">
              <div *ngIf="!fechasInvalidas[i]" class="m-2 p-3 bg-gray-200 rounded">
                <h3 class="text-center text-azul font-bold w-full my-2">{{'nuevo-entrenamiento' | translate}}</h3>
                <!-- Select Tipo de Entrenamiento -->
                <select #tipo class="rounded p-2 w-full text-black my-1 border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" (change)="establecerTipoNuevoEntrenamiento(tipo.value)">
                  <option value="" disabled selected>{{'sel-tipo-entrenamiento' | translate}}</option>
                  <option *ngFor="let tipo of getTipoEntrenamiento()" [value]="tipo">{{ tipo.toUpperCase() }}</option>
                </select>
                <!-- Descripcion Nuevo Entrenamiento -->
                <textarea [(ngModel)]="nuevoEntrenamiento.descripcion" [ngModelOptions]="{ standalone: true }" placeholder="{{'descripcion-entrenamiento' | translate}}" class="rounded p-2 w-full text-black my-1 border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
                <!-- Duracion Nuevo Entrenamiento -->
                <div class="grid grid-cols-2 gap-2 my-1">
                  <div>
                    <label class="block text-sm font-medium text-gray-700">{{'horas' | translate}}</label>
                    <input type="number" min="0" [(ngModel)]="nuevoEntrenamiento.duracion.hours" [ngModelOptions]="{ standalone: true }" class="rounded p-2 w-full text-black border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="0"/>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700">{{'minutos' | translate}}</label>
                    <input type="number" min="0" max="59" [(ngModel)]="nuevoEntrenamiento.duracion.minutes" [ngModelOptions]="{ standalone: true }" class="rounded p-2 w-full text-black border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="0"/>
                  </div>
                </div>
                <button [disabled]="fechasInvalidas[i]" type="button" class="w-full bg-azul p-2 text-white my-2 rounded-lg hover:text-blue-300 duration-1000" (click)="crearNuevoEntrenamiento(i)">{{'crear-entrenamiento' | translate}}</button>
              </div>
            </div>
            <!-- Contenedor Entrenamiento Existente -->
            <div class="col-span-full" *ngIf="usarEntrenamiento">
              <div *ngIf="!fechasInvalidas[i]" class="m-2 p-3 bg-gray-200 rounded">
                <!-- Select Entrenamiento Existente -->
                <label class="block text-sm font-medium text-gray-700">{{'selecciona-entrenamiento' | translate}}</label>
                <select [(ngModel)]="idEntrenamientoSeleccionado[i]" [ngModelOptions]="{ standalone: true }" class="rounded p-2 w-full text-black my-1 border border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option *ngFor="let ent of entrenamientosEquipo" [value]="ent.ID">{{ ent.descripcion }}</option>
                </select>
                <!-- Boton Establecer Entrenamiento Existente -->
                <button [disabled]="fechasInvalidas[i]" type="button" class="w-full bg-azul p-2 text-white my-2 rounded-lg hover:text-blue-300 duration-1000" (click)="seleccionarEntrenamiento(i)" [disabled]="!idEntrenamientoSeleccionado[i]">{{'establecer-entrenamiento' | translate}}</button>
              </div>
            </div>
          </div>
          <!-- Alert Entrenamiento Registrado para Dia -->
          <div *ngIf="!mostrarDia[i]" class="p-2">
            <nz-alert nzType="success" nzMessage="{{'entrenamiento-establecido' | translate}} {{'dia' | translate}} {{ i + 1 }}" nzShowIcon></nz-alert>
          </div>
        </ng-container>
        <!-- Boton Guardar Sesion Completa -->
        <div class="w-full flex justify-center">
          <button type="button" class="bg-azul text-white p-2 rounded-lg hover:text-blue-300 duration-1000" (click)="guardarSesionCompleta()">
              {{ 'guardar-sesion' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
